<template>
  <div class="studioport english_container">
    <myHeader />

    <div class="studio_banner">
      <div class="studio_banner_content">
        <h1
          class="fami"
          style="font-size: 80px; font-weight: 900; margin-bottom: 20px"
        >
          hecoos Studio
        </h1>
        <p class="enTwoProductDesc" style="padding-top: 0px; margin-top: 10px">
          End-to-end workflow precision: From concept to stage with hecoos
          studio
        </p>
        <button
          id="studio_download"
          class="callMe"
          @click="getdown"
          style="background-color: black"
        >
          Download Now
        </button>
      </div>
      <div class="gradient-bg">
        <div class="gradients-container">
          <div class="g1"></div>
          <div class="g2"></div>
          <div class="g3"></div>
          <div class="g4"></div>
          <div class="g5"></div>
          <div class="interactive"></div>
        </div>
      </div>
    </div>

    <div class="section_foundation">
      <div class="section_content">
        <p class="carousel-title wow fadeInUp">
          End-to-End Production Workflow
        </p>
        <button class="watch-movie-button wow fadeInUp" @click="showVideo">
          <img
            src="https://download.hecoos.com/enlightv/2025-17/474eb090ad7a5003fcc3f12e09a7120a.png"
            alt=""
          />
        </button>
      </div>
      <div class="scroll_container">
        <div class="foundation_video">
          <!-- <video autoplay loop muted
            src="https://download.hecoos.com/enlightv/2025-17/3e04d9ef0313721c372a09dc4de0cfae.mp4"></video> -->
          <img
            src="https://download.hecoos.com/enlightv/2025-20/74f6eb95683bca36efb3951249c6fdcf.png"
            alt=""
          />
        </div>
      </div>
    </div>

    <div>
      <div class="product colorBlack">
        <div class="tab">
          <p class="enProductTitle wow fadeInUp" style="margin-bottom: 0px">
            overview
          </p>
          <p class="wow fadeInUp enProductTitle">Key Functionality</p>
          <div class="switch" ref="switch_list">
            <!-- 为每个 span 绑定点击事件和动态类名 -->
            <span
              :class="{ select: currentTabIndex === 0 }"
              @click="selectTab(0)"
              style="line-height: 35px"
            >
              3D Previsualization
            </span>
            <span
              :class="{ select: currentTabIndex === 1 }"
              @click="selectTab(1)"
              style="line-height: 35px"
            >
              Projection Simulation
            </span>
            <span
              :class="{ select: currentTabIndex === 2 }"
              @click="selectTab(2)"
              style="line-height: 35px"
            >
              Lighting Programming
            </span>
            <span
              :class="{ select: currentTabIndex === 3 }"
              @click="selectTab(3)"
              style="line-height: 35px"
            >
              Broadcast Control
            </span>
            <span
              :class="{ select: currentTabIndex === 4 }"
              @click="selectTab(4)"
              style="line-height: 35px"
            >
              Live Control
            </span>
            <div
              class="underline"
              :style="{
                width: underlineWidth + 'px',
                left: underlineLeft + 'px',
              }"
            ></div>
          </div>
        </div>
        <!-- 产品内容部分 -->
        <div>
          <div class="content1 flexContent">
            <div class="studio" v-show="showContents[0]">
              <img
                src="https://download.hecoos.com/enlightv/2025-16/b5aecdcaf25f8dbedcd172d81269dc04.PNG"
                alt=""
                @click="handleClickStudioVideo('lOEbkxsE424')"
                class="wow fadeInUp"
              />
              <p class="textContent wow fadeInUp">
                hecoos uses a 3D visualization interface to pre-visualize the
                entire event process, accurately simulating stage elements such
                as video, lighting, mechanics, interaction, and directing.
                Artists and engineers collaborate through the pre-visualization
                to discuss and clearly establish every detail of the performance
                plan, providing a solid guarantee for improving on-site
                execution efficiency and accuracy.
              </p>
            </div>
            <div class="studio" v-show="showContents[1]">
              <img
                src="https://download.hecoos.com/enlightv/2025-16/dee68d234bdb109448c1e11e7731f2e0.PNG"
                alt=""
                @click="handleClickStudioVideo('r1hGusBsqE8')"
                class="wow fadeInUp"
              />
              <p class="textContent wow fadeInUp">
                Simulate the light path and image distortion of real projectors,
                accurately measure the illumination and shadowed areas of the
                projector in real environments, and easily complete the optical
                path design of various complex models through built-in
                projectors of multiple brands with different parameters.
              </p>
            </div>
            <div class="studio" v-show="showContents[2]">
              <img
                src="https://download.hecoos.com/enlightv/2025-16/b448228ae023f45c1fce4c8395ff4d6a.PNG"
                alt=""
                @click="handleClickStudioVideo('rqAiKVDJ_Jc')"
                class="wow fadeInUp"
              />
              <p class="textContent wow fadeInUp">
                Lighting effects play a crucial role in setting the stage
                atmosphere. hecoos integrates mainstream brand lighting fixtures
                and connects them via the Art-Net protocol, enabling
                pre-programming of lights, real-time control of actual fixtures
                on-site, and simulating realistic light and shadow effects in a
                3D scene, reproducing the vibrant and colorful lighting effects
                of the stage.
              </p>
            </div>
            <div class="studio" v-show="showContents[3]">
              <img
                src="https://download.hecoos.com/enlightv/2025-16/98557f4026cd18a7da6d82c0d18a7fe4.PNG"
                alt=""
                @click="handleClickStudioVideo('l0MLyvM0tro')"
                class="wow fadeInUp"
              />
              <div class="textContent wow fadeInUp">
                <p>
                  The system integrates various types of cameras (such as crane
                  cameras, track cameras, etc.), allowing for pre-visualization
                  of camera shots. With a timeline-based control method, it
                  enables precise director switching. Additionally, it can
                  manage and generate electronic scripts based on CUE points,
                  seamlessly connecting directing design with on-site execution.
                  Cloud-based collaboration ensures smooth teamwork, and it can
                  perform unattended director switching tasks.
                </p>
              </div>
            </div>

            <div class="studio" v-show="showContents[4]">
              <img
                src="https://download.hecoos.com/enlightv/2025-16/ac165d73db88a18204ce18210f683fbd.png"
                alt=""
                @click="handleClickStudioVideo('7dG6F7x46rM')"
                class="wow fadeInUp"
              />
              <div class="textContent">
                <p>
                  Studio seamlessly connects the pre-visualization process with
                  on-site execution. As the central control hub for multimedia
                  equipment during the project debugging phase, Studio ensures
                  stable and coordinated operation between devices with its
                  precise communication and control capabilities. Multi-person
                  collaborative debugging makes team coordination smoother and
                  more efficient.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 会员注册 -->
    <div class="bg3">
      <div class="form-container">
        <h1 class="wow fadeInUp soul enProductTitle">Member Registration</h1>
        <div class="register_content">
          <div class="input-group wow fadeInUp">
            <input type="text" placeholder="Name" v-model="form.rname" />
            <input type="text" placeholder="Company" v-model="form.company" />
          </div>
          <div class="phone-verify-group wow fadeInUp">
            <div class="phone-verify-container wow fadeInUp">
              <input
                class="phone-input"
                type="email"
                placeholder="E-mail"
                v-model="form.email"
              />
              <button
                :disabled="!isPhoneValid || isCountingDown"
                @click="obtainCode"
                class="verify-code-button"
              >
                {{ isCountingDown ? ` ${countdown}s` : "Get" }}
              </button>
            </div>
            <input
              type="text"
              placeholder="Verify code"
              v-model="form.verifyCode"
              class="verify-input"
            />
          </div>
          <div class="input-group wow fadeInUp">
            <input
              type="password"
              placeholder="Password"
              v-model="form.password"
            />
            <input
              type="password"
              placeholder="Re-enter password"
              v-model="form.confirmPassword"
            />
          </div>
          <div class="input-group wow fadeInUp">
            <input type="text" placeholder="City" v-model="form.city" />
            <input type="text" placeholder="Job" v-model="form.position" />
          </div>
          <div class="input-group wow fadeInUp">
            <select
              placeholder="Seniority"
              :class="{ none_select: !this.form.workDuration }"
              v-model="form.workDuration"
            >
              <option value="" disabled selected>Seniority</option>
              <option v-for="item in workDurationList" :value="item.name">
                {{ item.name }}
              </option>
            </select>
          </div>
          <p class="tip wow fadeInUp" style="text-align: left">
            To ensure a quick approval process, please provide accurate and
            valid information.
          </p>
          <button
            class="next-button wow fadeInUp"
            :disabled="!isButtonEnabled"
            @click="goRegister"
          >
            Next step
          </button>
        </div>
      </div>
    </div>
    <!-- 软件订阅 -->
    <div class="bg4">
      <div class="subscription-container wow fadeInUp">
        <h2 class="title wow fadeInUp enProductTitle">Software subscription</h2>
        <div class="subscription_container">
          <div
            v-for="(item, index) in subscriptionOptions"
            :key="index"
            class="subscription-item"
          >
            <h3 :class="getClass(item.stylecolor)">{{ item.title }}</h3>
            <div style="height: 120px">
              <div v-if="item.price" class="price">
                {{ item.price }}<span class="z">/weekly plan</span>
              </div>
              <p v-else class="description">{{ item.description }}</p>
            </div>

            <button class="btn" @click="goToPage(item)">Learn more</button>
          </div>
        </div>
      </div>
    </div>

    <div class="bg6">
      <div id="app">
        <!-- 下载部分 -->
        <div class="download-section wow fadeInUp">
          <div class="left-content">
            <img
              src="https://download.hecoos.com/enlightv/2025-17/5943a715df38eb4f86c5d9e218bd51dd.png"
              alt="下载图标"
            />
          </div>
          <div class="right-content wow fadeInUp">
            <h2>Download</h2>
            <p>
              Download now, get familiar with the software, and start creating
              new realities!
            </p>
            <div class="le">
              <button class="download-btn" @click="getdown">
                Software download
              </button>

              <a href="https://download.hecoos.com/hecoos/hecoosGuide.pdf"
                ><button class="guide-btn">Download guide</button></a
              >
            </div>
          </div>
        </div>
        <!-- 学习方案部分 -->
        <div class="learning-plan-section">
          <div class="left-content wow fadeInUp">
            <h2>Learning Plan</h2>
            <p>A learning experience that suits your needs and pace</p>
            <div class="le">
              <router-link
                :to="{ name: 'enVideoTutorial', hash: '#specific-position' }"
                class="setting_a2"
              >
                <button class="more-btn">Learn more</button>
              </router-link>
              <router-link
                :to="{
                  name: 'enCaseDemonstration',
                  hash: '#specific-position',
                }"
                class="setting_a2"
              >
                <button class="customize-btn">Customiz learning plan</button>
              </router-link>
            </div>
          </div>
          <div class="right-content wow fadeInUp">
            <img
              src="https://download.hecoos.com/enlightv/2025-17/f7ffa329c3461ca49c38e4a61a158e39.png"
              alt="学习场景"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- <myText /> -->
    <myInquire />
    <myFooter />
    <BackToTop></BackToTop>
    <videoPlayback
      v-if="showVideoPlayer"
      @close="handleCloseVideo"
      :videoUrl="videoUrl"
    />
    <youtubeVideo v-if="youtubeVideoId" :youtubeVideoId.sync="youtubeVideoId"/>
  </div>
</template>

<script>
import { getOSSData } from "@/utils/uploadOss.js";
import BackToTop from "@/components/en_pc/BackToTop";
import myFooter from "@/components/en_pc/myFooter.vue";
import myHeader from "@/components/en_pc/myHeader.vue";
import myInquire from "@/components/en_pc/myInquire.vue";
import youtubeVideo from "@/components/en_pc/youtubeVideo";
// import MyText from "@/components/en_pc/myText.vue";
import videoPlayback from "@/components/pc/videoPlayback.vue";
import axios from "axios";
import { getCaptcha, adminRegister, getEnglishCaptcha } from "@/api/api";
import { Message } from "element-ui";
export default {
  components: {
    myHeader,
    myFooter,
    myInquire,
    // MyText,
    BackToTop,
    videoPlayback,
    youtubeVideo
  },

  data() {
    return {
      underlineWidth: 0,
      underlineLeft: 0,
      // 新增变量，用于记录当前选中的 tab 索引
      currentTabIndex: 0,
      // 新增数组，用于控制每个产品内容的显示状态
      showContents: [true, false, false, false, false, false],
      form: {
        rname: "",
        phone: "",
        verifyCode: "",
        password: "",
        confirmPassword: "",
        email: "",
        company: "",
        city: "",
        position: "",
        workDuration: "",
      },
      isCountingDown: false,
      countdown: 60,
      workDurationList: [
        { name: "1years" },
        { name: "2years" },
        { name: "3years" },
        { name: "4years" },
        { name: "5years" },
        { name: "6years" },
        { name: "7years" },
        { name: "8years" },
        { name: "9years" },
        { name: "More than 10 years" },
      ],
      errorMessages: [], // 新增：收集所有错误信息
      bannertext:
        "hecoos以三维可视化界面预演完整的活动过程，精准模拟视频、灯光、机械、交互、导播等舞台元素，艺术家与工程师通过预演协作探讨并清晰确立演出方案的每一处细节，是提升现场执行效率与准确率的坚实保障",

      formRows: [
        [
          {
            label: "真实姓名",
            type: "input",
            inputType: "text",
            name: "realName",
            placeholder: "Real name", // 添加占位符文本
          },
          {
            label: "邮箱",
            type: "input",
            inputType: "email",
            name: "email",
            placeholder: "email", // 添加占位符文本
          },
        ],
        [
          {
            label: "手机号",
            type: "input-with-button",
            inputType: "text",
            name: "phone",
            clickHandler: function () {
              this.sendVerificationCode();
            },
            text: "Get Verification code",
            placeholder: "cell-phone number", // 添加占位符文本
          },
          {
            label: "验证码",
            type: "input",
            inputType: "text",
            name: "verificationCode",
            placeholder: "Verification code", // 添加占位符文本
          },
        ],
        [
          {
            label: "设置密码1",
            type: "input",
            inputType: "password",
            name: "password",
            placeholder: "administrator", // 添加占位符文本
          },
          {
            label: "确认密码",
            type: "input",
            inputType: "password",
            name: "confirmPassword",
            placeholder: "Confirm password", // 添加占位符文本
          },
        ],
        [
          {
            label: "所在公司名称",
            type: "input",
            inputType: "text",
            name: "companyName",
            placeholder: "Company Name", // 添加占位符文本
          },
          {
            label: "所在城市",
            type: "input",
            inputType: "text",
            name: "city",
            placeholder: "city", // 添加占位符文本
          },
        ],
        [
          {
            label: "职位",
            type: "input",
            inputType: "text",
            name: "position",
            placeholder: "position", // 添加占位符文本
          },
          {
            label: "从业时间",
            type: "input",
            inputType: "text",
            name: "workExperience",
            placeholder: "Employment time", // 添加占位符文本
          },
        ],
      ],
      formData: {},
      isSending: false,
      countdown: 60,
      timer: null,

      subscriptionOptions: [
        {
          title: "Subscription version",
          stylecolor: "color_one",
          price: "$12",
          path: "/en/SoftwareSubscriptions",
        },
        {
          title: "Offline version",
          description:
            "Independent encryption dongle, can work offline as well",
          path: "/en/offlineversion",
          stylecolor: "color_two",
        },
      ],

      hue1: 0,
      hue2: 0,
      showVideoPlayer: false,
      videoUrl:
        "https://download.hecoos.com/enlightv/2025-17/a7b39397e5b52ac2f16d0e201a71d1f3.mp4",
      youtubeVideoId:''
    };
  },
  mounted() {
    window.addEventListener("mousemove", this.handleMouseMove);
    this.$nextTick(() => {
      this.updateUnderlinePosition();
      this.setupSpanResizeObservers();
      window.addEventListener("resize", this.updateUnderlinePosition);
    });
  },
  beforeDestroy() {
    window.removeEventListener("mousemove", this.handleMouseMove);
    window.removeEventListener("resize", this.updateUnderlinePosition);
  },
  computed: {
    isButtonEnabled() {
      return (
        // 所有必填字段都填写且密码一致
        this.form.rname &&
        this.form.email &&
        this.form.verifyCode &&
        this.form.password &&
        this.form.confirmPassword &&
        this.form.company &&
        this.form.city &&
        this.form.position &&
        this.form.workDuration &&
        this.form.password === this.form.confirmPassword
      );
    },
    isPhoneValid() {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return emailRegex.test(this.form.email);
    },
  },
  methods: {
    handleClickStudioVideo(videoId){
      this.youtubeVideoId = videoId
    },
    //     handleClick(index) {
    //   // 这里可以根据点击的选项index，实现具体的业务逻辑，比如跳转到对应详情页
    //   console.log(`点击了${this.subscriptionOptions[index].title}的进一步了解按钮`);
    // }
    getClass(colorClass) {
      const classMap = {
        color_one: "class-one",
        color_two: "class-two",
      };
      return classMap[colorClass] || "";
    },
    handleMouseMove(event) {
      const x = event.clientX / window.innerWidth;
      const y = event.clientY / window.innerHeight;

      this.hue1 = Math.floor(x * 360);
      this.hue2 = Math.floor(y * 360);
    },
    // 显示视频播放器
    showVideo() {
      this.showVideoPlayer = true;
      document.body.style.overflow = "hidden"; // 禁止页面滚动
    },
    // 显示视频播放器
    showVideo() {
      this.showVideoPlayer = true;
      document.body.style.overflow = "hidden"; // 禁止页面滚动
    },
    // 处理关闭视频
    handleCloseVideo() {
      this.showVideoPlayer = false;
      document.body.style.overflow = "auto"; // 恢复页面滚动
    },

    // goVedio() {
    //   window
    //     .open
    //     // "https://download.hecoos.com/enlightv/2025-11/3682ee8f4d99851fede9ebb32b9f1b10.mp4"
    //     ();
    // },
    // goToAbout() {
    //   this.$router.push("https://www.artbook.top/");
    // },
    // 新增方法，用于处理 tab 切换
    selectTab(index) {
      this.currentTabIndex = index;
      // 重置所有内容的显示状态为 false
      this.showContents = this.showContents.map(() => false);
      // 将当前选中的内容显示状态设为 true
      this.showContents[index] = true;
      this.updateUnderlinePosition();
    },
    updateUnderlinePosition() {
      const switchList = this.$refs.switch_list;
      if (switchList) {
        const span = switchList.querySelectorAll("span")[this.currentTabIndex];
        const switchListRect = switchList.getBoundingClientRect();
        const spanRect = span.getBoundingClientRect();

        // 获取 span 的左右 padding 值
        const computedStyle = window.getComputedStyle(span);
        const paddingLeft = parseFloat(computedStyle.paddingLeft);
        const paddingRight = parseFloat(computedStyle.paddingRight);

        // 计算去除 padding 后的宽度
        this.underlineWidth = spanRect.width - paddingLeft - paddingRight;
        // 计算去除 padding 后的左侧偏移量
        this.underlineLeft = spanRect.left - switchListRect.left + paddingLeft;
      }
    },
    // 文字宽度变化监听
    setupSpanResizeObservers() {
      const spans = this.$refs.switch_list.querySelectorAll("span");
      const resizeCallback = () => {
        this.updateUnderlinePosition();
      };
      spans.forEach((span) => {
        const observer = new ResizeObserver(resizeCallback);
        observer.observe(span);
      });
    },
    goToPage(item) {
      this.$router.push({ path: item.path });
    },

    //下载软件接口
    getdown() {
      const config = {
        method: "post", // 请求方法
        url: "https://www.hecoos.com/api/index/hecoosPath", // 请求 URL
        timeout: 5000, // 请求超时时间（毫秒）
      };
      axios(config)
        .then((res) => {
          if (res) {
            const { version, packageUrl } = res.data;
            let file_name = `hecoos Studio v${version}.exe`;
            getOSSData(packageUrl, file_name);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    jumpTo(url) {
      this.$router.push(url);
    },

    // 获取验证码
    obtainCode() {
      // 先校验邮箱格式
      if (!this.isPhoneValid) {
        Message.error("Please enter the correct email format");
        return;
      }

      let postData = {
        email: this.form.email,
      };
      getEnglishCaptcha(postData).then((res) => {
        if (res.code === 200) {
          Message.success(res.message);
          this.startCountdown();
        } else {
          Message.error(res.message);
        }
      });
    },
    // 姓名校验
    checkZh(str) {
      // ^[A-Za-z]+$ ：仅字母，至少 2 个字符
      let reg = /^[A-Za-z]{2,20}$/;
      return reg.test(str);
    },

    // 公司名称校验
    checkZhCompany(str) {
      // 允许字母、空格、& . ( ) / - ，至少 2 个字符
      let reg = /^[A-Za-z&\/\.\(\) -]{2,}$/;
      return reg.test(str);
    },

    // 验证码校验（假设为6位数字）
    checkVerifyCode(str) {
      let reg = /^\d{6}$/;
      return reg.test(str);
    },

    // 职位校验（至少2个字符，可以是中英文）
    checkPosition(str) {
      let reg = /^.{2,}$/;
      return reg.test(str);
    },
    // 密码校验
    checkPassword(str) {
      return str.length >= 6;
    },
    // 城市校验
    checkCity(str) {
      //允许字母、空格、'-'（如 New York、San Francisco）
      let reg = /^[A-Za-z -]{2,}$/;
      return reg.test(str);
    },
    // 统一表单校验方法
    validateForm() {
      const errors = [];
      // 收集所有错误
      if (!this.form.rname.trim()) errors.push("Please enter your name.");
      if (!this.isPhoneValid)
        errors.push("The email format is incorrect, please re-enter");

      if (this.form.verifyCode && !this.checkVerifyCode(this.form.verifyCode))
        errors.push("Please enter a 6-digit verification code");
      if (this.form.password && !this.checkPassword(this.form.password))
        errors.push("The password length should be at least 6 digits");
      if (this.form.password !== this.form.confirmPassword)
        errors.push("Entered passwords differ!");
      if (!this.form.company.trim()) errors.push("Please enter your company.");
      if (!this.form.city.trim()) errors.push("Please enter the city");
      if (!this.form.position.trim()) errors.push("Please enter your job");
      if (!this.form.workDuration) errors.push("Please choose seniority");

      // 延迟显示错误
      if (errors.length > 0) {
        errors.forEach((msg, index) => {
          setTimeout(() => {
            Message.error(msg);
          }, 500 * index);
        });
        return false;
      }

      return true;
    },
    // 注册
    goRegister() {
      // 执行完整表单校验
      if (!this.validateForm()) {
        return;
      }

      adminRegister(this.form).then((res) => {
        if (res.code === 200) {
          Message.success(res.message);
          this.$router.push("/en/login");
        } else {
          Message.error(res.message);
        }
      });
    },
    startCountdown() {
      this.isCountingDown = true;
      let timer = setInterval(() => {
        this.countdown--;
        if (this.countdown === 0) {
          clearInterval(timer);
          this.isCountingDown = false;
          this.countdown = 60;
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/studio_banner.scss";
</style>
<style scoped lang="scss">
@import "@/styles/en_pc/wsc.scss";
@import "@/styles/optimize_adaptation.scss";
.studioport {
  .default_font {
    font-size: 24px;
    font-weight: 500;
    line-height: 66px;
  }
}
select {
  display: block;
  width: 100%;
  font-size: 14px;
  padding: 12px 8px;
  border-radius: 6px;
  border: none;
  // margin: 0 10px;
  margin-bottom: 10px;
  background-color: #333333;
  color: #fff;
}
select.none_select {
  color: #757575;
}
select:focus-visible {
  border: none;
  outline: none;
}
.fami {
  // font-family: YourFontName;
  font-weight: 900;
}
.section_content {
  .carousel-title {
    font-size: 80px;
  }
}

.product {
  width: 100%;
}

.tab {
  /* height: 500px; */
  background-color: #e8e8f1;
  text-align: center;
  color: #000;
  padding: 80px 120px 0;
}

.switch {
  margin-top: 30px;
  position: relative;

  span {
    display: inline-block;
    margin: 0 25px;
    font-size: 24px;
    font-weight: 700;
    padding: 10px 5px;
    line-height: 50px;
    cursor: pointer;
  }
}

.select {
  // border-bottom: 3px solid #2a82e4;
}

.content1 {
  width: 100%;
  background-color: #121416;
  color: #fff;
}
.flexContent {
  padding: 80px 120px;
  .studio {
    max-width: 1100px;
    margin: 0 auto;
    display: flex;
    gap: 40px;
    overflow: hidden;
    img {
      width: 50%;
    }
    .textContent {
      flex: 1;
      margin-top: 0px;
      // text-indent: 48px;
      line-height: 37px;
      // text-align: justify;
      // margin-bottom: 30px;
      // vertical-align: top;
      text-align: left;
      font-size: 24px;
    }
  }
}
// .studio {
//   padding: 80px 120px;

//   img {
//     display: block;
//     margin: 0 auto;
//     width: 1058px;
//     height: 682px;
//   }
// }

// .textContent {
//   width: 1058px;
//   // height: 100px;
//   margin: 30px auto 0;
//   font-size: 20px;
//   text-align: left;
// }

.underline {
  position: absolute;
  bottom: 0;
  height: 3px;
  background-color: #2a82e4;
  transition: all 0.3s ease;
}

.callMe {
  display: inline-block;
  text-decoration: none;
  padding: 16px 24px;
  line-height: 32px;
  border-radius: 40px;
  background-color: #147cf5;
  margin: 0 auto;
  margin-top: 100px;
  font-size: 22px;
  cursor: pointer;
  color: #fff;
  transition: all 0.3s ease;
  border: none;
}

.callMe:hover {
  transform: scale(1.05);
  background-color: #fff;
  color: #147cf5;
}
.bgc {
  display: flex;
  justify-content: center;
  align-items: center;
  background: url("https://download.hecoos.com/enlightv/2025-17/88bbd52c2dca3a58360b8aa5ad07d60d.png");
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 100vh;
  position: relative;
}

.register_content {
  width: 100%;

  border-radius: 15px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
  text-align: center;
  color: #fff;
  position: relative;
  z-index: 1;
}

.register_content h2 {
  margin-bottom: 20px;
  font-size: 32px;
}

.register_content p {
  margin-bottom: 30px;
  font-size: 20px;
}

.input-group {
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
}

.input-group input,
.phone-verify-group input {
  width: 48%;
  padding: 15px;
  border: none;
  border-radius: 8px;
  background-color: #333;
  color: #fff;
  font-size: 18px;
  transition: border-color 0.3s;
}

.phone-verify-group {
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
}

.phone-verify-container {
  display: flex;
  width: 48%;
  position: relative;
}

.phone-input {
  flex: 1;
  font-size: 18px;
  padding: 10px;
  border: none;
  border-radius: 5px;
  background-color: #333;
  color: #fff;
  width: 100%;
  height: auto;
}

.verify-code-button {
  width: 120px;
  padding: 14px 10px;
  background-color: #333;
  color: #fff;
  border: none;
  border-radius: 0 5px 5px 0;
  cursor: pointer;
  height: auto;
  position: absolute;
  right: 0;
  font-size: 18px;
}

.verify-input {
  width: 48%;
  padding: 15px;
  border: none;
  border-radius: 8px;
  background-color: #333;
  color: #fff;
  height: auto;
  font-size: 18px;
}

.next-button {
  width: 100%;
  padding: 16px 0;
  border: none;
  border-radius: 8px;
  background-color: #fff;
  color: #222;
  cursor: pointer;
  margin-bottom: 20px;
  font-size: 22px;
  transition: all 0.3s;
}

.next-button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.link-container {
  font-size: 18px;
  color: #fff;
  cursor: pointer;
}
@media screen and (max-width: 1440px) {
  .switch {
    span {
      font-size: 22px;
    }
  }
}
@media screen and (max-width: 1300px) {
  .switch {
    span {
      font-size: 20px;
    }
  }
}
@media screen and (max-width: 1210px) {
  .switch {
    span {
      font-size: 18px;
    }
  }
}
@media screen and (max-width: 1140px) {
  .switch {
    span {
      font-size: 16px;
    }
  }
}
@media screen and (max-width: 1070px) {
  .switch {
    span {
      font-size: 14px;
    }
  }
}
</style>
